import inView from "in-view";

import Navigation from "../modules/navigation";
import InsightsFilter from "../modules/insightsFilter";
import InsightsGeneratePagination from "../modules/insightsGeneratePagination";
import InsightsPagination from "../modules/insightsPagination";

export default {
  init() {
    // JavaScript to be fired on all pages
    // console.log("we have es6 hooray!");

    // add js class to body
    const body = document.querySelector("body");
    body.classList.add("js");

    // init modules
    // navigation
    Navigation();

    // should only load if the module exists on the page
    const insightsBlock = document.querySelectorAll(".b-allInsights");
    // console.log(insightsBlock.length);
    if (insightsBlock.length > 0) {
      InsightsFilter();
      InsightsGeneratePagination();
      InsightsPagination();
    }

    /*
    |--------------------------------------------------------------------------
    | inView
    |--------------------------------------------------------------------------
    */

    // handler for when you land in the middle of a page (either you already scrolled, then refresh, or click on some anchor link for some reason. This is a rare case, but what happens is that scrolling up causes js-inView to be added, but its a fade-up effect, which looks weird

    // convert this to non-jquery someday

    // get the last inView within the set
    function checkOtherInView() {
      // get all the js-trackView
      const elementsSet = $(".js-trackView");
      // console.log(elementsSet);
      // filter for those with inview
      const elementsShownSet = $(elementsSet).filter(".js-inView");
      // console.log(elementsShownSet);
      // then get the last in view
      const lastShownElement = $(elementsShownSet).filter(":last");
      // console.log(lastShownElement);
      //
      const indexOfLast = $(elementsSet).index(lastShownElement);
      // console.log(indexOfLast);

      // if there are things above the last in view, loop over and add js-inView class to them
      if (indexOfLast > 0) {
        for (let i = 0; i < indexOfLast; i += 1) {
          elementsSet[i].classList.add("js-inView");
        }
      }
    }

    // configure inView

    inView(".js-trackView").on("enter", el => {
      // just add class once
      el.classList.add("js-inView");
      // console.log("inview element:");
      // console.log(el);
      checkOtherInView();
    });

    // set options only after page load
    const setInviewOptions = function setInviewOptions() {
      // console.log("inview options set");
      inView.offset({
        bottom: 100, // only trigger after has crossed 100px into viewport
      });
      inView.threshold(0); // any amount
    };

    // run one second after page done to set options for rest
    setTimeout(setInviewOptions, 1000);

    /*
    |--------------------------------------------------------------------------
    | credits
    |--------------------------------------------------------------------------
    */

    const allLinks = document.links;

    for (let i = 0, linksLength = allLinks.length; i < linksLength; i += 1) {
      if (allLinks[i].hostname !== window.location.hostname) {
        allLinks[i].target = "_blank";
      }
    }

    /*
    |--------------------------------------------------------------------------
    | credits
    |--------------------------------------------------------------------------
    */
    const credit = "Inspired by Sedgwick Richardson";
    console.log(credit);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./assets/scripts/routes/common.js